import React from 'react';
import { FieldArray } from 'formik';
import { Question, Answer } from '../../gds-api-client';
import EditAnswers from './EditAnswerField';
import { RsvpDropdown } from './Dropdown';
import styles from './styles.scss';
import { Person } from '../interfaces';

interface EditHouseholdAnswerP {
  questions: Question[];
  answers: Answer[];
}

interface EditEventAnswerP {
  questions: Question[];
  people: Person[];
  eventId: string;
}

const EditContainer: React.FC<{}> = ({ children }) => <div className={styles.editContainer}>{children}</div>;

export const EditHouseholdAnswers: React.FC<EditHouseholdAnswerP> = ({ questions, answers }) => {
  return (
    <EditContainer>
      <FieldArray
        name="answers"
        render={({ push }): React.ReactElement => {
          return <EditAnswers name="answers" questions={questions} answers={answers || []} addNew={push} />;
        }}
      />
    </EditContainer>
  );
};

export const EditEventAnswers: React.FC<EditEventAnswerP> = ({ questions, people, eventId }) => {
  return (
    <EditContainer>
      {people.map((p, i) => {
        const invitationIndex = p.invitations.findIndex(idx => idx.eventId === eventId);
        if (invitationIndex === -1) return null;

        const rsvpStatus = p.invitations[invitationIndex].rsvp;
        const nameDataPath = `people[${i}].invitations[${invitationIndex}]`;
        return (
          <div key={p.id}>
            <div className={styles.guestName}>
              {p.firstName} {p.lastName}
            </div>
            <RsvpDropdown name={`${nameDataPath}.rsvp`} />
            {!!rsvpStatus && (
              <FieldArray
                name={`${nameDataPath}.answers`}
                render={({ push }): React.ReactElement => {
                  return (
                    <EditAnswers
                      name={`${nameDataPath}.answers`}
                      questions={questions}
                      answers={p?.invitations[invitationIndex].answers || []}
                      addNew={push}
                    />
                  );
                }}
              />
            )}
          </div>
        );
      })}
    </EditContainer>
  );
};
